import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Dialog, IconButton } from 'react-toolbox';
import { connect } from 'react-redux';
import LocationInfo from 'crewInspection/locationInfo';
import YesAndNo from 'crewInspection/yesAndNo';
import Assessment from 'crewInspection/assessment';
import S from 'modal.scss';
import Loading from 'components/Loading';
import styles from 'styles/input.scss';
import {
  clearValidation, crewInspectionCreate, updatePhaseTask,
} from 'actionCreators';
import PhaseType from 'types/phase';

class CrewInspectionModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = {
    auditorName: '',
    crewId: '',
    installerType: '',
    subfloorType: '',
    helpers: '',
    badge: '',
    badgeWhy: '',
    uniform: '',
    uniformWhy: '',
    yardSign: '',
    yardSignWhy: '',
    oilShield: '',
    oilShieldWhy: '',
    tarp: '',
    tarpWhy: '',
    properTools: '',
    properToolsWhy: '',
    overallAssessment: '',
    errors: {},
    tab: 1,
  }

  static VALIDATIONS = {
    crewId: true,
    auditorName: true,
    overallAssessment: true,
  }

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
    document.location.reload();
  }

  updateFormData = (crewInspectionData) => {
    const { phase: { id, project_number, surface_type: { name } } } = this.props;
    this.setState(crewInspectionData, () => {
      if (crewInspectionData.tab === 4) {
        const { installerType, subfloorType, helpers, badge, badgeWhy, uniform,
                uniformWhy, yardSign, yardSignWhy, oilShield, oilShieldWhy,
                tarp, tarpWhy, properTools, properToolsWhy, crewId } = this.state;
        this.props.crewInspectionCreate({
          auditor_name: this.state.auditorName,
          installer_type: installerType,
          subfloor_type: subfloorType,
          helpers,
          badge,
          badge_why: badgeWhy,
          uniform,
          uniform_why: uniformWhy,
          yard_sign: yardSign,
          yard_sign_why: yardSignWhy,
          oil_shield: oilShield,
          oil_shield_why: oilShieldWhy,
          tarp,
          tarp_why: tarpWhy,
          proper_tools: properTools,
          proper_tools_why: properToolsWhy,
          overall_assessment: this.state.overallAssessment,
          surface_type: name,
          project_number,
          phase_id: id,
          crew_id: crewId,
        })
        .then(() => { this.handleClose(); })
        .catch(() => {});
      }
    });
  }

  showTab = () => {
    const { tab, auditorName, installerType, subfloorType, helpers, badge,
            badgeWhy, uniform, uniformWhy, yardSign, yardSignWhy, oilShield,
            oilShieldWhy, tarp, tarpWhy, properTools, properToolsWhy,
            overallAssessment, crewId } = this.state;
    const { phase } = this.props;
    switch (tab) {
      case 1:
        return (<LocationInfo
          phase={phase}
          updateFormData={this.updateFormData}
          crewId={crewId}
          installerType={installerType}
          subfloorType={subfloorType}
          helpers={helpers}
        />);
      case 2:
        return (<YesAndNo
          phase={phase}
          updateFormData={this.updateFormData}
          badge={badge}
          badgeWhy={badgeWhy}
          uniform={uniform}
          uniformWhy={uniformWhy}
          yardSign={yardSign}
          yardSignWhy={yardSignWhy}
          oilShield={oilShield}
          oilShieldWhy={oilShieldWhy}
          tarp={tarp}
          tarpWhy={tarpWhy}
          properTools={properTools}
          properToolsWhy={properToolsWhy}
        />);
      case 3:
        return (<Assessment
          phase={phase}
          updateFormData={this.updateFormData}
          auditorName={auditorName}
          overallAssessment={overallAssessment}
        />);
      default:
        return (<Loading />);
    }
  }

  render = () => {
    const { active, errors: serverErrors } = this.props;
    return (<Dialog
      active={active} className={S.modal} type="fullscreen"
      onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
    >
      <div className={styles.errored}>
        {Object.keys(serverErrors).length > 0 &&
        <span className={styles.error}>This action could not be completed.</span>}
      </div>
      <IconButton icon="close" className={S.close} onClick={this.handleClose} />
      <h5>Crew Inspection Report</h5>
      {this.showTab()}
    </Dialog>);
  }
}

CrewInspectionModal.propTypes = {
  active: PropTypes.bool.isRequired,
  clearValidation: PropTypes.func.isRequired,
  crewInspectionCreate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    name: PropTypes.arrayOf(PropTypes.string),
  }),
};

CrewInspectionModal.defaultProps = { active: false };

export default connect(state => ({ errors: state.crewInspection.uploadError }), {
  clearValidation,
  crewInspectionCreate,
  updatePhaseTask,
})(CrewInspectionModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/crewInspectionModal.jsx